import propertyOrNull from 'contest/utils/property-or-null';
import user from '../models/user';

export default {
    create,
    defaultProperties,
    fromJSON,
    isPersisted,
    equal,
};

function create(properties) {
    return Object.assign({}, defaultProperties(), properties);
}

function equal(obj1, obj2) {
    return obj1 && obj2 && obj1.id === obj2.id;
}

function isPersisted(obj) {
    return !!obj.id;
}

function defaultProperties() {
    return {
        id: null,
        message: null,
        createdAt: new Date().toString(),
        annotation: null,
        isDeleted: false,
        creator: null,
        design: null,
        designId: null, // questionable. Added to ease DesignStore changes
        permission: {
            canDelete: false,
            canEdit: false,
            secondsRemainingEdit: 0,
            secondsRemainingDelete: 0,
        },
        links: {
            self: null,
            delete: null,
            edit: null,
        },
    };
}

// Translate from Contests HAL API to local data structure
function fromJSON(json) {
    if (!json) {
        return null;
    }

    const defaults = defaultProperties();

    return {
        id: parseInt(json.id, 10),
        designId: parseInt(json.entryId, 10),
        message: json.content,
        formattedMessage: json.formattedContent,
        annotation:
            json._embedded.annotation.x && json._embedded.annotation.y
                ? { x: json._embedded.annotation.x || null, y: json._embedded.annotation.y || null }
                : null,
        permission: Object.assign({}, defaults.permission, json._embedded.permission || {}),
        links: {
            self: propertyOrNull(json._links.self, 'href'),
            edit: propertyOrNull(json._links.edit, 'href'),
            delete: propertyOrNull(json._links.delete, 'href'),
        },
        createdAt: json.timeCreatedString,
        creator: user.fromJSON(json._embedded.author),
    };
}



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/design-details/models/design-comment.js